module.exports = __webpack_public_path__ + "img/pin_exchange_blue.bf2eed57.svg";